import type { CortesTextAnchor } from './types';

const clamp01 = (value: number): number => Math.min(1, Math.max(0, value));

export type HeadlineAnchorDragOptions = {
  /** 'y' keeps x pinned — used by the full-width Text Bar. */
  axis?: 'xy' | 'y';
};

/** Translate a Cortes headline center-anchor by canvas fractions. */
export function applyHeadlineAnchorDrag(
  start: Pick<CortesTextAnchor, 'x' | 'y'>,
  dx: number,
  dy: number,
  options: HeadlineAnchorDragOptions = {},
): { x: number; y: number } {
  return {
    x: options.axis === 'y' ? start.x : clamp01(start.x + dx),
    y: clamp01(start.y + dy),
  };
}
